import { apiFetch } from './client.js';

export async function pairWithCode(code) {
  return apiFetch('/devices/pair', {
    method: 'POST',
    auth: false,
    body: { code },
  });
}

export async function createPairingSession(body) {
  return apiFetch('/devices/pairing-sessions', {
    method: 'POST',
    auth: false,
    body,
  });
}

export async function getPairingSessionStatus(sessionId) {
  return apiFetch(`/devices/pairing-sessions/${sessionId}/status`, {
    auth: false,
  });
}
